//! Recieved help from Jake with nav bar routing.

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { Profile } from "../profile";
import app from "../../firebase";
import "./NavBar.css";
import { ProfileScreen, ChatRoom, JournalScreen } from "../../screens";
import { Link, BrowserRouter as Router } from "react-router-dom";
import "./NavBar.css";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(175),
  },
  title: {
    flexGrow: 1,
    height: 20,
    fontSize: 45,
    fontStyle: "italic",
  },
}));

export const NavBar = () => {
  const classes = useStyles();
  const history = useHistory();

  const [auth] = React.useState(true);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePath = (path) => {
    history.push(path);
  };

  return (
    <div className={classes.root}>
      {/* <AppBar position='sticky' style={{ backgroundColor: 'darksalmon' }}> */}
      <AppBar position='sticky' style={{ backgroundColor: 'darksalmon' }}>
        <Typography variant='h6' className={classes.title} id='title'>
          Bloom Hope
        </Typography>
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            // color="d"
            aria-label="menu"
          ></IconButton>
          {auth && (
            // {auth && (
            <div>
              <Router>
                <IconButton
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="darksalmon"
                >
                  <MenuIcon />
                </IconButton>

                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={open}
                  onClose={handleClose}
                >
                  {/* <MenuItem component={ProfileScreen} to='/profile'>
                    Profile
                  </MenuItem> */}
                  {/* <MenuItem component={ChatRoom} to='/chat'>
                    Chat
                  </MenuItem> */}
                  {/* <MenuItem component={JournalScreen} to='/journal'>
                    journal
                  </MenuItem> */}

                  <MenuItem onClick={() => handlePath("/profile")}>
                    Profile
                  </MenuItem>
                  <MenuItem onClick={() => handlePath("/journal")}>
                    Journal
                  </MenuItem>
                  <MenuItem onClick={() => handlePath("/chat")}>Chat</MenuItem>
                  <MenuItem onClick={() => handlePath("/resources")}>
                    Resources
                  </MenuItem>
                  <MenuItem onClick={() => handlePath("/board")}>
                    Affirmation
                  </MenuItem>
                  <MenuItem onClick={() => handlePath('/')}>Sign Out</MenuItem>
                </Menu>
              </Router>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
};
